import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { PlayBtn, Balance, FooterBtn, FooterBox, Space } from "./FooterStyled";
// import { Globals, Protocol } from "../../../lib/constants";
// import { MessageFactory } from "../../../lib/messages";
import { ReactComponent as RandomSVG } from "../../../svg/random.svg";
import { ReactComponent as AutorulesSVG } from "../../../svg/autorules.svg";
import { ReactComponent as CleanSVG } from "../../../svg/clean.svg";
import currencies from "../../../lib/currencies/currencies";

// region sounds

// endregion

import useBetOperations from "../bet/useBetOperations";

import useSound from "use-sound";
import forwardSound from "../../../audio/goForward.mp3";
import playSound from "../../../audio/play.mp3";
import clearSound from "../../../audio/clear.mp3";

export default function FooterNormal({
  n,
  play,
  handleAbove,
  random,
  clean,
  sendSelectedToApp,
  clickable,
  handleNotification,
  toFix,
  minBet,
  maxBet,
  currency,
  sound,
  volume,
}) {
  const st = useSelector((s) => s);
  const { bet, gameMode } = st;
  // const { gameMode } = st.userSettings;

  const [ubet, , , multiply, divide] = useBetOperations(
    bet,
    true,
    sound,
    handleNotification,
    toFix,
    minBet,
    maxBet,
    currency,
  );

  const [clearAnim, setclearAnim] = useState(false);
  const [randAnim, setrandAnim] = useState(false);
  const [halfAnim, sethalfAnim] = useState(false);
  const [multAnim, setmultAnim] = useState(false);
  const [autoAnim, setautoAnim] = useState(false);
  // const [playAinm, setplayAinm] = useState(false);
  const [playPress, setplayPress] = useState(false);
  const [playUnpress, setplayUnpress] = useState(false);
  const [forwardSFX] = useSound(forwardSound, { volume });
  const [playSFX] = useSound(playSound, { volume });
  const [clearSFX] = useSound(clearSound, { volume });

  useEffect(() => {
    if (clickable) {
      setplayPress(false); // არ ვიცი აქ უნდა ეს თუ  58-ე ხაზზე
      setplayUnpress(true);
      setTimeout(() => {
        setplayUnpress(false);
      }, 200);
    }
  }, [clickable]);

  return (
    <div
      style={{
        width: "100%",
        height: "107px",
        marginTop: "19px",
        pointerEvents: clickable ? "auto" : "none",
      }}
    >
      <FooterBox className="FooterBox">
        <FooterBtn
          id="divide"
          onClick={() => {
            sethalfAnim(true);
            setTimeout(() => {
              sethalfAnim(false);
              divide();
            }, 300);
          }}
          anim={halfAnim}
          mode80={gameMode === "80"}
          mode40={gameMode === "40"}
        >
          <div className="white" />
          1/2
        </FooterBtn>
        <Balance
          onClick={() => {
            if (sound) forwardSFX();

            handleAbove("SetBet");
          }}
          mode80={gameMode === "80"}
          mode40={gameMode === "40"}
        // toggleBtn={GoBackHandler}
        >
          <span style={{ marginRight: '2px', textTransform:'none' }}>{currencies[currency]}</span>
          {ubet}
        </Balance>
        <FooterBtn
          id="multiply"
          onClick={() => {
            setmultAnim(true);
            setTimeout(() => {
              setmultAnim(false);
              multiply();
            }, 300);
          }}
          anim={multAnim}
          mode80={gameMode === "80"}
          mode40={gameMode === "40"}
        >
          <div className="white" />
          2x
        </FooterBtn>
      </FooterBox>
      <Space />
      <FooterBox>
        <FooterBtn
          onClick={() => {
            clean();
            setrandAnim(true);
            setTimeout(() => {
              setrandAnim(false);
            }, 200);
            gameMode === "80" ? random(80) : random(40);
          }}
          anim={randAnim}
          mode80={gameMode === "80"}
          mode40={gameMode === "40"}
        >
          <div className="white" />
          <RandomSVG className="randomSVG" />
        </FooterBtn>
        <FooterBtn
          onClick={() => {
            if (n > 0) {
              setautoAnim(true);
              if (sound) forwardSFX();
              setTimeout(() => {
                setautoAnim(false);
                handleAbove("autorules");
                sendSelectedToApp();
              }, 200);
            } else {
              handleNotification("Choose at least 1 ball");
            }
          }}
          anim={autoAnim}
          mode80={gameMode === "80"}
          mode40={gameMode === "40"}
        >
          <div className="white" />
          <AutorulesSVG className="autoSVG" />
        </FooterBtn>
        <FooterBtn
          mode80={gameMode === "80"}
          mode40={gameMode === "40"}
          onClick={() => {
            clean();
            if (sound && n > 0) clearSFX();
            setclearAnim(true);
            setTimeout(() => {
              setclearAnim(false);
            }, 200);
          }}
          anim={clearAnim}
        >
          <div className="white" />
          <CleanSVG className="CleanSVG" />
        </FooterBtn>
        <PlayBtn
          playPress={playPress}
          playUnpress={playUnpress}
          onClick={() => {
            if (ubet > st.balance) {
              return handleNotification("Not enough balance");
            }
            if (n > 0) {
              if (sound) playSFX();
              setplayPress(true);
              play();
            } else {
              handleNotification("Choose at least 1 ball");
            }
          }}
          mode80={gameMode === "80"}
          mode40={gameMode === "40"}
        >
          <div className="white" />
          Play
        </PlayBtn>
      </FooterBox>
    </div>
  );
}
